import { atomWithStorage } from "jotai/utils";

type ConsultationExportIdsByQuoteId = Record<string, string>;

const consultationExportIdsAtom = atomWithStorage<ConsultationExportIdsByQuoteId>(
  "consultation-export-ids",
  {},
  undefined,
  { getOnInit: true },
);

const withConsultationExportId = (
  exportIds: ConsultationExportIdsByQuoteId,
  quoteId: string,
  exportId: string | null,
): ConsultationExportIdsByQuoteId => {
  const { [quoteId]: _previousExportId, ...otherExportIds } = exportIds;
  return exportId ? { ...otherExportIds, [quoteId]: exportId } : otherExportIds;
};

export { consultationExportIdsAtom, withConsultationExportId };
